module.exports = __webpack_public_path__ + "static/media/ESCAPE 2_01.ef62d402.mp3";